import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { VariedadService } from "../../variedad/service/variedad.service";
import {
  RespCountriesObservation
} from "../model/observation.model";
import { ObservationService } from "../service/observation.service";
import { MapOptions, Map } from "leaflet";
import { PageEvent } from "@angular/material/paginator";
import { map, startWith } from "rxjs/operators";
import { DialogFilterComponent } from "../../widget/dialog-filter/dialog-filter.component";
import { UserService } from "../../user/service/user.service";
@Component({
  selector: "app-observation-list-view",
  templateUrl: "./observation-list-view.component.html",
  styleUrls: ["./observation-list-view.component.css"],
})
export class ObservationListViewComponent implements OnInit {

  // NORMAL FILTERS
  @Input() p_variety_name!: any | null;
  @Input() p_farmer_name!: any | null;


  // ADVANCE FILTER
  @Input() p_any_date!: any | null;
  @Input() p_date_exactly!: any | null;
  @Input() p_date_init!: any | null;
  @Input() p_date_end!: any | null;
  @Input() p_month!: any | null;
  @Input() p_user_id!: any | null;
  @Input() p_username!: any | null;
  @Input() p_place!: any | null;

  @Input() p_country!: any | null;
  @Input() p_is_original!: any | null;
  @Input() p_is_public!: any | null;

  constructor(
    private observationService: ObservationService,
    private variedadService: VariedadService,
    public dialog: MatDialog,
    public userService: UserService,
    public router: Router,
  ) { }

  cardContentList!: any[];
  gpsCoordinateList!: any[];

  varietyObservationSubs$!: Subscription;
  page_control = 0;
  page_size_control = 20;
  _length = 100;
  _showFirstLastButtons = true;
  _pageSizeOptions: number[] = [5, 20, 40, 60, 100, 500];
  viewType: string = "catalogo";

  variety_control = new FormControl();
  farmer_control = new FormControl();
  country_value = 'Perú';

  province_control = new FormControl();
  district_control = new FormControl();
  locality_control = new FormControl();


  varietal_group_control = new FormControl();
  farmer_id_control = new FormControl();
  is_original_control = new FormControl();

  filteredOptionsVariety!: Observable<string[]>;
  filteredOptionsCountry!: Observable<RespCountriesObservation>;
  filteredOptionsFarmer!: Observable<string[]>;

  observationVarietyObservation!: Observable<any>;
  map!: Map;
  mapOptions!: MapOptions;
  badgeFilter: number | null = null;

  paramsData = {
    p_variety_name: null,
    p_farmer_name: null,
    p_any_date: true,
    p_date_exactly: null,
    p_date_init: null,
    p_date_end: null,
    p_month: null,
    p_user_id: null,
    p_username: null,
    p_place: null,

    p_country: null,
    p_is_original: null,
    p_is_public: null,
  };

  observation_count: any = "---";
  variety_count: any = "---";
  observer_count: any = "---";
  farmer_count: any = "---";

  ngOnInit(): void {
    this.filteredOptionsVariety = this.variety_control.valueChanges.pipe(
      startWith(""),
      map((_value) => this.fnSearchVarietyNames(_value))
    );

    this.filteredOptionsFarmer = this.farmer_control.valueChanges.pipe(
      startWith(""),
      map((_value) => this.fnSearchFarmerNames(_value))
    );

    this.filteredOptionsCountry = this.observationService.getCountries();

    this.fnSearchVarietyObservation("ngOnInit");

    this.fnLoadFilter();
  }

  fnSearchVarietyObservation(_from: string | null = null) {

    const _var = {

      page: this.page_control,
      page_size: this.page_size_control,
      variety_name: this.p_variety_name,
      country: this.country_value === 'Todos' ? null : this.country_value,
      region: null,
      farmer_name: this.p_farmer_name,
      province: this.province_control.value,
      district: this.district_control.value,
      locality: this.locality_control.value,
      observation_date: this.p_date_exactly,
      observation_date_start: this.p_date_init,
      observation_date_end: this.p_date_end,
      user_id: this.p_user_id,
      is_public: true,
      varietal_group: this.varietal_group_control.value,
      farmer_id: this.farmer_id_control.value,
      is_original: this.is_original_control.value,
      months: this.p_month,
      sort_by: 'observation_date',
    };

    this.cardContentList = [];
    this.gpsCoordinateList = [];
    const _gpsCoordinateList: any[] = [];
    this.observationVarietyObservation = this.observationService.getSearch(_var);
    this.varietyObservationSubs$ = this.observationVarietyObservation.subscribe(
      (_resp: any) => {


        this.observation_count = _resp.counts.observation_count;
        this.variety_count = _resp.counts.variety_count;
        this.observer_count = _resp.counts.observer_count;
        this.farmer_count = _resp.counts.farmer_count;

        this._length = _resp.pagination.total_count;
        _resp.data.map((_element: any) => {
          const _coordinate = {
            latitude: _element.latitude,
            longitude: _element.longitude,
            location: _element.location,
          };
          _gpsCoordinateList.push(_coordinate);

          this.cardContentList.push({
            card_id: _element.variety_observation_id,
            card_id_1: _element.variety_id,
            card_name: _element.variety_name,
            card_id_2: _element.species_id,
            card_name_2: _element.species_name,
            card_value_1: _element.synonyms,
            card_date: _element.observation_date,
            card_value_2: _element.location,
            card_user_id: _element.user_id,
            card_username: _element.username,
            card_user_image_url: _element.user_image_url,
            card_image_url: _element.observation_image_url,
          });
        });
      }
    );
    this.gpsCoordinateList = _gpsCoordinateList;
  }

  fnSearchVarietyNames(variety_value: string): string[] {
    const _optionList: string[] = [];

    const _var = {
      variety_name: variety_value,
      is_original: true,
      is_public: true,
      page: null,
      page_size: null,
    };

    this.observationService.getVarietyNames(_var)
      .subscribe((_resp: any) => {
        _resp.data.map(
          (_element: string) => _optionList.push(_element));
      });

    return _optionList;
  }

  fnSearchFarmerNames(farmer_value: string): string[] {
    const _optionList: string[] = [];
    const _var = {
      page: 0,
      page_size: 100,
      farmer_name: farmer_value,
      is_public: true
    };
    this.observationService.getFarmerNames(_var,)
      .subscribe((_resp: any) => {
        _resp.data.map(
          (_element: string) => {
            _optionList.push(_element);
          });
      });
    return _optionList;
  }

  fnClearFilters() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/observaciones"]).then(() => {
      })
    })
  }

  fnOpenDialog(bt: any, _width: number): void {
    const _element = bt._elementRef.nativeElement;
    const _rect = _element
      ? _element.getBoundingClientRect()
      : { top: 0, left: 0 };
    const _dialogRef = this.dialog.open(DialogFilterComponent, {
      width: _width + "px",
      data: this.paramsData,
      position: {
        top: _rect.bottom + "px",
        left: _rect.right - _width + "px",
      },
    });
    _dialogRef.afterClosed().subscribe((_result: any) => {
      if (_result) {
        let _badgeFilters = 0;
        _badgeFilters = _badgeFilters + (_result.p_date_exactly ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_date_init ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_date_end ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_month ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_user_id ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_place ? 1 : 0);
        this.badgeFilter = _badgeFilters > 0 ? _badgeFilters : null;
        this.fnParamsDataChange(_result)
      }
    });
  }

  fnParamsDataChange(_paramsData: any, _param: string | null = null) {
    const _cParamsData = this.paramsData;
    if (_param == 'p_variety_name') {
      _cParamsData.p_variety_name = _paramsData.p_variety_name;
      this.fnGoToView('observaciones', _cParamsData)
    } else if (_param == 'p_farmer_name') {
      _cParamsData.p_farmer_name = _paramsData.p_farmer_name;
      this.fnGoToView('observaciones', _cParamsData)
    }
    else {
      _paramsData.p_date_exactly = this.fnFormatDate(_paramsData.p_date_exactly);
      _paramsData.p_date_init = this.fnFormatDate(_paramsData.p_date_init);
      _paramsData.p_date_end = this.fnFormatDate(_paramsData.p_date_end);
      this.paramsData = _paramsData;
      this.fnGoToView('observaciones', _paramsData)
    }
  }

  fnFormatDate(_date: any | null): string | null {
    try {
      return _date.toISOString().slice(0, 10).replace("T", " ");
    } catch (error) {
      return _date;
    }
  }

  fnGoToView(_route: string, _params: any | null) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_route], {
        queryParams: _params
      }).then(() => {
      })
    })
  }

  fnLoadFilter() {

    // NORMAL FILTER

    if (this.p_variety_name) {
      this.variety_control.setValue(this.p_variety_name);
      this.paramsData.p_variety_name = this.p_variety_name;
    }

    if (this.p_farmer_name) {
      this.farmer_control.setValue(this.p_farmer_name);
      this.paramsData.p_farmer_name = this.p_farmer_name;
    }

    // ADVANCE FILTER
    if (this.p_user_id) {
      this.userService.getUserById(this.p_user_id).subscribe(
        (x) => {
          this.paramsData.p_username = x.data.username;
          this.paramsData.p_user_id = this.p_user_id;
          this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
        }
      );
    }

    if (this.p_date_exactly) {
      this.paramsData.p_date_exactly = this.p_date_exactly;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
    }

    if (this.p_date_init) {
      this.paramsData.p_date_init = this.p_date_init;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
    }

    if (this.p_date_end) {
      this.paramsData.p_date_end = this.p_date_end;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
    }

    if (this.p_month) {
      this.paramsData.p_month = this.p_month;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
    }

  }

  handlePageEvent(event: PageEvent) {
    this.page_control = event.pageIndex;
    this.page_size_control = event.pageSize;
    this._length = event.length;
    this.fnSearchVarietyObservation("handlePageEvent");
  }


  fnGoToCatalogView() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/catalogo"]).then(() => {
      })
    })
  }

  fnGetAllCoordinates() {
    this.gpsCoordinateList = [];
    // para que se ve un componente con nuevos datos hay que dar tiempo ocultándolo
    const _req = {
      is_public: true
    }
    this.observationService.getGpsLocations(_req).subscribe(
      (_req) => {
        if (_req.success) {
          this.gpsCoordinateList = _req.data;
        }
      }
    );
  }
}
